export default "__VITE_ASSET__e20ca1ca__"